<template>
  <div class="template-select-row" :class="user.selected ? 'selected' : ''" @click="$emit('to-user', {id: user.id, value: !user.selected, isProcedureDateRelated: user.isProcedureDateRelated})" >
    <div class="template-select-col__name">
      <h4>{{ user.name }}</h4>
    </div>
    <div class="template-select-col desc">
      {{user.description}}
    </div>
    <div class="template-select-col date">
      <span class="bhGray2--text text-nowrap">
        {{ user.creationDate | moment("MMMM Do, YYYY")}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplatesSelectTableRow',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
  }
}
</script>

<style lang="scss">
.template-select {

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;
    border: 2px solid $bh-white;
    display: flex;
    align-items: center;
    width: 100%;
    background: $bh-white;
    cursor: pointer;
    &:hover {
      background: $bh-white !important;
      border-color: $bh-blue--3;
    }
    &.selected {
      border-color: $bh-blue;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;
    &.desc {
      width: 30%;
      font-size: 0.7rem;
      line-height: 0.8rem;
    }
    &.date {
      font-size: 0.7rem;
      text-align: right;
      flex-grow: 1;
    }
    &__name {
      width: 40%;
      padding-left: 10px;
      h4 {
        margin-bottom: 0;
      }
      cursor: pointer;
    }
    h4 {
      margin-bottom: 0;
    }
    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
      text-align: right;
    }

    .text-number {
      font-size: 1.125rem;
    }
  }
}
</style>
